﻿import * as React from 'react';
import { Asset } from '../models/asset';
import { ColumnEntry } from '../models/column-entry';
import { ColumnHeader } from '../models/column-header';
import { LookupItem } from '../models/lookup-item';
import { Technology } from '../models/technology';
import { LocationZone } from '../models/Locations/location-zone';
import { Vendor } from '../models/vendor';
import { PWDates } from '../utilities/pw-dates';
import { Department } from '../models/department';
import { TextBox } from 'devextreme-react';
import { CompStandard } from '../models/comp-standard';
import { ProductStandard } from '../models/product-standard';
import { ResponseInformation } from '../models/response-information';
import { ResponseError } from '../models/response-error';
import { EditType } from '../models/enums';

export class DataTemplates {

    static EditMarkerCellRender(e: any) {
        if (e.data) {
            switch (e.data.editType) {
                case EditType.Insert:
                    return <div><i className="dx-icon-add" /></div>;
                case EditType.Update:
                    return <div><i className="dx-icon-edit" /></div>;
                case EditType.Delete:
                    return <div><i className="dx-icon-trash" /></div>;
                default:
                    return <div></div>;
            }
        }
        return <div></div>;
    }

    static ProductUomItemRender(item: LookupItem) {
        return (
            <div id={`productUom${item.id}`} className="lookup-item-container">
                <div className="lookup-item-name">{item.name}</div>
            </div>
        );
    }

    static ProductFormItemRender(item: LookupItem) {
        return (
            <div id={`productForm${item.id}`} className="lookup-item-container">
                <div className="lookup-item-name">{item.name}</div>
            </div>
        );
    }

    static ProductPackageControlItemRender(item: LookupItem) {
        return (
            <div id={`productPackageControl${item.id}`} className="lookup-item-container">
                <div className="lookup-item-name">{item.name}</div>
            </div>
        );
    }
    static ProductHazardItemRender(item: LookupItem) {
        return (
            <div id={`productHazard${item.id}`} className="lookup-item-container">
                <div className="lookup-item-name">{item.name}</div>
            </div>
        );
    }

    static ProductStorageItemRender(item: LookupItem) {
        return (
            <div id={`productStorage${item.id}`} className="lookup-item-container">
                <div className="lookup-item-name">{item.name}</div>
                <div className="lookup-item-description">{item.description}</div>
            </div>
        );
    }

    static ProductShippingConditionItemRender(item: LookupItem) {
        return (
            <div id={`productShippingCondition${item.id}`} className="lookup-item-container">
                <div className="lookup-item-name">{item.name}</div>
            </div>
        );
    }

    static ProductLightItemRender(item: LookupItem) {
        return (
            <div id={`productLight${item.id}`} className="lookup-item-container">
                <div className="lookup-item-name">{item.name}</div>
            </div>
        );
    }

    static ProductSpecialHandlingItemRender(item: LookupItem) {
        return (
            <div id={`productSpecialHandling${item.id}`} className="lookup-item-container">
                <div className="lookup-item-name">{item.name}</div>
            </div>
        );
    }

    static ProductUnitsDisplayedOnCoaItemRender(item: LookupItem) {
        return (
            <div id={`productUnitsDisplayedOnCoa${item.id}`} className="lookup-item-container">
                <div className="lookup-item-name">{item.name}</div>
            </div>
        );
    }

    static ProductGravimetricCalculationItemRender(item: LookupItem) {
        return (
            <div id={`productGravimetricCalculation${item.id}`} className="lookup-item-container">
                <div className="lookup-item-name">{item.name}</div>
                <div className="lookup-item-description">{item.description}</div>
            </div>
        );
    }

    static ProductPreparationDesignItemRender(item: LookupItem) {
        return (
            <div id={`preparationDesign${item.id}`} className="lookup-item-container">
                <div className="lookup-item-name">{item.name}</div>
                <div className="lookup-item-description">{item.description}</div>
            </div>
        );
    }

    static ProductRequiresAnalysisItemRender(item: LookupItem) {
        return (
            <div id={`productRequiresAnalysis${item.id}`} className="lookup-item-container">
                <div className="lookup-item-name">{item.name}</div>
            </div>
        );
    }

    static LotItemRenderColumn(data: any) {
        if (data) {
            return (
                <div className="asset-render-label">{data.batchName}</div>
            );
        }
        else {
            return (<div></div>);
        }
    }

    static AssetItemRender(data: any) {
        //this appears in dropdown list 
        if (data) {
            return (
                <div>
                    <div className="item-main">{data.assetName}</div>
                    <div className="item-sub">{`${data.description} ${data.contractAgencyName ? data.contractAgencyName : ''} ${data.modelNumber}`}</div>
                </div >
            );
        }
        else
            return (<div></div>);
    }


    static GcAssetItemRender(data: any) {
        //this appears in dropdown list 
        if (data) {
            return (
                <div className="pw-two-column-grid">
                    <div className="item-main">{`${data.assetNumber} - ${data.assetName}`}</div>
                    <div className="item-sub">{data.description}</div>
                </div >
            );
        }
        else
            return (<div></div>);
    }


    static BalanceItemRender(data: any) {
        //this appears in dropdown list 
        if (data) {
            return (
                <div id={`balanceAssetNumber-${data.assetNumber}`}>
                    <div className="item-main">{data.assetNumber}</div>
                    <div className="item-sub">{data.modelNumber}</div>
                </div >
            );
        }
        else
            return (<div></div>);
    }

    static BalanceItemRenderById(e: any) {
        //this appears in dropdown list 
        if (e.data && e.data.balance) {
            let balance = e.data.balance;

            return (
                <div id={`balanceAssetNumber-${balance.assetNumber}`}>
                    <div className="item-main">{balance.assetNumber}</div>
                    <div className="item-sub">{balance.modelNumber}</div>
                </div >
            );
        }
        else
            return (<div></div>);
    }

    /*
Underneath the asset number we need Instrument Name, Contract Agency, and Model Number.
(Asset Example (01661): HPLC-10, Agilent, 1200).
*/


    static CalibrationLogBookGroupItemRender(data: any) {
        //this appears in dropdown list 
        if (data) {
            return (
                <div>
                    <div className="item-main">{data.name}</div>
                    <div className="item-sub">{data.calibrationStandard}</div>
                </div >
            );
        }
        else
            return (<div></div>);
    }

    static CalibrationLogBookGroupFieldRender(data: any) {
        //have to use a Readonly textbox per Devextreme requirements
        return (
            <div className="calibration-group-render">
                <TextBox className="calibration-group-render-textbox" defaultValue={data && data.name} readOnly={true} />
                <span className="calibration-group-render-label">{data && data.calibrationStandard}</span>
            </div>
        );
    }

    static CalibrationLogBookEntryItemRender(data: any) {
        //this appears in dropdown list 
        if (data) {
            return (
                <div>
                    <div className="item-main">{PWDates.getDateString(data.expirationDate)}</div>
                </div >
            );
        }
        else
            return (<div></div>);
    }

    static CalibrationLogBookEntryFieldRender(data: any) {
        //have to use a Readonly textbox per Devextreme requirements
        return (
            <div className="calibration-entry-render">
                <TextBox className="calibration-entry-render-textbox" defaultValue={data && PWDates.getDateString(data.expirationDate)} readOnly={true} />
            </div>
        );
    }

    static LotFieldRenderColumn(data: any) {
        //have to use a Readonly textbox per Devextreme requirements
        return (
            <div>
                <TextBox className="asset-render-textbox" defaultValue={data ? data.batchName : ''} readOnly={true} />
            </div>
        );
    }

    static AssetFieldRenderColumn(data: any) {
        //have to use a Readonly textbox per Devextreme requirements
        //this appears in grid when user clicks on cell
        if (data) {
            return (
                <div>
                    <TextBox className="item-main" defaultValue={data && data.assetName} readOnly={true} />
                    <span className="textbox-item-sub">{data && data.description}</span>
                </div>
            );
        }
        else
            return (<div><TextBox className="asset-render-textbox" readOnly={true} /></div>);
    }

    static BalanceFieldRenderColumn(data: any) {
        //have to use a Readonly textbox per Devextreme requirements
        //this appears in grid when user clicks on cell
        if (data) {
            return (
                <div className="pw-two-column-grid">
                    <TextBox className="item-main" defaultValue={data && data.assetNumber} readOnly={true} />
                    <span className="pw-selectbox-description-column">{data && data.modelNumber}</span>
                </div>
            );
        }
        else
            return (<div><TextBox className="asset-render-textbox" readOnly={true} /></div>);
    }

    static AssetFieldRender(data: any) {
        //have to use a Readonly textbox per Devextreme requirements
        if (data) {
            const invalidCss = data.isInvalid ? " invalid-data" : "";

            return (
                <div className="asset-render">
                    <TextBox className={`asset-render-textbox${invalidCss}`}
                        defaultValue={data && data.assetNumber ? data.assetNumber : ''} readOnly={true} />
                    <span className="asset-render-label">{data.assetName ? data.assetName : ''}</span>
                </div>
            );
        }
        else
            return (<TextBox className="asset-render-textbox" readOnly={true} />);
    }

    static GcColumnHeaderFieldRender(data: ColumnHeader) {
        //have to use a Readonly textbox per Devextreme requirements
        if (data) {
            return (
                <div className="column-render">
                    <TextBox className="asset-render-textbox" defaultValue={data && data.columnId ? data.columnId.toString() : undefined} readOnly={true} />
                    <span className="asset-render-label">{data && data.description}</span>
                </div>
            );
        }
        else
            return (<div> <TextBox className="asset-render-textbox" readOnly={true} /></div >);
    }

    static GcColumnEntryFieldRender(data: ColumnEntry) {
        //have to use a Readonly textbox per Devextreme requirements
        if (data) {
            return (
                <div className="asset-render">
                    <TextBox className="asset-render-textbox" defaultValue={data && data.entryNumber ? data.entryNumber.toString() : undefined} readOnly={true} />
                    <span className="asset-render-label">{data && data.runDate}</span>
                </div>
            );
        }
        else
            return (<div><TextBox className="asset-render-textbox" readOnly={true} /></div>);
    }

    static AssetHorizontalFieldRender(data: any) {
        //have to use a Readonly textbox per Devextreme requirements
        return (
            <div className="asset-horizontal-render">
                <TextBox className="asset-render-textbox" defaultValue={data && data.assetName} readOnly={true} />
                <span className="asset-render-label">{data && data.description}</span>
            </div>
        );
    }

    static BenchSheetAssetRenderItem(data: Asset) {
        return (
            <div>
                <div className="selectItem1"><span className="asset-dropdown-label">Asset#: </span><span>{data.assetName}</span></div>
                <div className="selectItem2"><span className="asset-dropdown-label">Model#: </span><span>{data.description}</span></div>
            </div>
        );
    }

    static BenchSheetAssetRenderField(data: Asset) {
        return (
            <div>
                <div className="selectItem1">{data.assetNumber} - {data.modelNumber}</div>
            </div>
        );
    }

    static TechnologyItemRender(data: Technology) {
        return (
            <div className="lookup-item-container">
                <div className="lookup-item-name">{data.name} - {data.description}</div>
            </div>
        );
    }

    static InstrumentItemRender(data: Asset) {
        console.log("InstrumentItemRender");
        console.log(data);

        if (data) {
            const invalidCss = data.isInvalid ? " invalid-data" : "";

            let assetName = `${data.formattedAssetNumber}${(data.assetName ? (` - ${data.assetName}`) :'' )}`;

            return (
                <div>
                    <div className={`selectItem1${invalidCss} lookup-item-name`}>{assetName}</div>
                    <div className="item-sub">{data.description}</div>
                </div>
            );
        }
        else
            return (<div></div>);
    }

    static GcColumnItemRender(data: ColumnHeader) {
        return (
            <div>
                <div className="selectItem1">{data.columnId} - {data.description}</div>
            </div>
        );
    }

    static GcEntryItemRender(data: ColumnEntry) {
        return (
            <div>
                <div className="selectItem1">({data.entryNumber}) {data.entryId} - {PWDates.getDateString(data.runDate)}</div>
            </div>
        );
    }

    static LookupItemRender(item: LookupItem) {
        return (
            <div className="lookup-item-container">
                <div className="lookup-item-name">{item.name}</div>
                <div className="lookup-item-description">{item.description}</div>
            </div>
        );
    }

    static LookupItemTitleDescriptionRender(item: LookupItem) {
        return (
            <div>
                <div className="lookup-item-name">{item.name}</div>
                <div className="item-sub">{item.description}</div>
            </div>
        );
    }

    static GravimetricCalculationsLookupItem(item: LookupItem) {
        return (
            <div className="gravimetric-calculations-lookup-item-container">
                <div className="lookup-item-name">{item.name}</div>
                <div className="lookup-item-description">{item.description}</div>
            </div>
        );
    }

    static LookupItemRenderColumn(data: any) {
        //have to use a Readonly textbox per Devextreme requirements
        //this appears in grid when user clicks on cell
        if (data) {
            return (
                <div>
                    <TextBox className="item-main" defaultValue={data && data.name} readOnly={true} />
                    <span className="textbox-item-sub">{data && data.name}</span>
                </div>
            );
        }
        else
            return (<div><TextBox className="asset-render-textbox" readOnly={true} /></div>);
    }

    static LookupItemNameOnlyTemplate(item: LookupItem) {
        return (
            <div>
                <div className="lookup-item-name">{item.name}</div>
            </div>
        );
    }

    static EhsTemplate(item: LookupItem) {
        return (
            <div>
                <div id={`ehsItem-${item.id}`}>{item.name}</div>
            </div>
        );
    }

    static ResponseMessageTemplate(message: ResponseInformation) {
        return (
            <div>
                <div className="pw-bold" id={`rm-${message.title}`}>{message.title}</div>
                <div className="pw-red">{message.message}</div>
            </div>
        );
    }

    static ResponseErrorTemplate(error: ResponseError) {
        return (
            <div>
                <div className="pw-bold" id={`rm-${error.title}`}>{error.title}</div>
                <div className="pw-red">{error.message}</div>
            </div>
        );
    }

    static CompStandardTemplate(standard: ProductStandard) {
        return (
            <div>
                <div id={standard.productStandardId}>{standard.standardsManufacturerName ?
                    standard.standardsManufacturerName : 'NA'} - {standard.catalogNumber}</div>
            </div>
        );
    }

    static ProductStandardTemplate(standard: ProductStandard) {
        return (
            <div>
                <div id={standard.productStandardId}>{standard.standardsManufacturerName ?
                    standard.standardsManufacturerName : 'NA'} - {standard.catalogNumber}</div>
            </div>
        );
    }

    static LookupItemNameOnlyFieldRender(data: LookupItem) {
        if (data) {
            //have to use a Readonly textbox per Devextreme requirements
            return (
                <div className="asset-horizontal-render">
                    <TextBox
                        className="lookup-item-name"
                        placeholder="na"
                        defaultValue={data && data.name}
                        readOnly={true} />
                </div>
            );
        }
        else
            return (
                <div>
                    <TextBox className="asset-horizontal-render" placeholder="na" readOnly={true} />
                </div>);
    }

    static DepartmentFieldRender(data: Department) {
        //have to use a Readonly textbox per Devextreme requirements
        return (
            <div className="asset-horizontal-render">
                <TextBox className="lookup-item-name" defaultValue={data && data.name} readOnly={true} />
            </div>
        );
    }

    static DepartmentTemplate(item: Department) {
        return (
            <div>
                <div>{item.name}</div>
            </div>
        );
    }

    /*
    static LocationFieldRender(data: Location) {
        //have to use a Readonly textbox per Devextreme requirements
        return (
            <div className="asset-horizontal-render">
                <TextBox className="asset-render-textbox" defaultValue={data && data.} readOnly={true} />
            </div>
        );
    }
    */

    static LocationTemplate(item: LocationZone) {
        return (
            <div>
                <div>{item.name}</div>
            </div>
        );
    }

    static VendorFieldRender(data: Vendor) {
        //have to use a Readonly textbox per Devextreme requirements
        return (
            <div className="asset-horizontal-render">
                <TextBox className="asset-render-textbox" defaultValue={data && data.name} readOnly={true} />
            </div>
        );
    }

    static VendorTemplate(item: Vendor) {
        return (
            <div>
                <div>{item.name}</div>
            </div>
        );
    }

    static UomItemRenderColumn(data: any) {
        if (data && data.name) {
            return (
                <div>
                    <span className="item-main">{data.name}</span>
                </div>
            );
        }
        else
            return (<div></div>);
    }

    static UomFieldRenderColumn(e: any) {
        //have to use a Readonly textbox per Devextreme requirements
        //this appears in grid when user clicks on cell
        if (e && e.data && e.data.concentrationUom) {
            return (
                <div>
                    <TextBox className="item-main" defaultValue={e.data.concentrationUom.name} />
                    <span className="textbox-item-sub">{e.data.concentrationUom.description}</span>
                </div>
            );
        }
        else
            return (<div><TextBox className="asset-render-textbox" readOnly={true} /></div>);
    }
}

export default DataTemplates;
